import {
  UPDATE_ACCOUNT_REQUEST,
  UPDATE_ACCOUNT_SUCCESS,
  UPDATE_ACCOUNT_FAILURE,
} from "../actions/account";

const initialState = {
  state: "idle" as "idle" | "loading" | "success" | "failure",
  error: null as string | null,
};

export default function updateAccount(state = initialState, action: any) {
  switch (action.type) {
    case UPDATE_ACCOUNT_REQUEST:
      return { state: "loading" as const, error: null };
    case UPDATE_ACCOUNT_SUCCESS:
      return { state: "success" as const, error: null };
    case UPDATE_ACCOUNT_FAILURE:
      return { state: "failure" as const, error: action.payload?.message ?? null };
    default:
      return state;
  }
}
